































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import Add from "./article/add.vue";
import Edit from "./article/edit.vue";
import QrcodeVue from 'qrcode.vue'
@Component({
  components: {
    Add,
    Edit,
    QrcodeVue
  },
})
export default class extends Mixins(MyList) {
  dispatchType = "article/list";
  dispatchTypeDelete = "article/delete";

  infoModalVisible = false;

  cateList = [];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "标题", dataIndex: "title" },
    { title: "分类", dataIndex: "cate_list", scopedSlots: { customRender: "cate" } },
    { title: "图片", dataIndex: "image_path", scopedSlots: { customRender: "picurl" } },
    { title: "描述", dataIndex: "desc" },
    { title: "阅读数", dataIndex: "read_count" },
    // { title: "状态", dataIndex: "publish_status" },
    { title: "链接", dataIndex: "short_url", scopedSlots: { customRender: "shorturl" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  handleDCopy(shortUrl: string) {

  }

  async loadCate() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("articleCate/list");
    if (res && res.Data && res.Data.data && res.Data.data.length > 0) {
      console.log('cate_list', res.Data);
      this.cateList = res.Data.data;
    }
    this.spinLoading = false;
  }

  mounted() {
    this.loadCate();
    this.loadData();
  }
}
